var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "101px",
    height: "100px",
    viewBox: "0 0 101 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphs/driver") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-Entrance---None-state",
    transform: "translate(-599.000000, -475.000000)",
    fill: "#DDDDDD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "main-panel",
    transform: "translate(94.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "driver-card",
    transform: "translate(415.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphs/driver",
    transform: "translate(90.310897, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M81.1235909,100 C81.1678546,98.8109858 81.1811949,97.6393142 81.1811949,96.5 C81.1811949,83.5213084 67.3055852,73 50.1891532,73 C33.0727213,73 19.1971116,83.5213084 19.1971116,96.5 C19.1971116,97.6505615 19.2076583,98.8212408 19.2474029,100 L6.61890804,100 L0.914553891,88.3320713 C-0.393722144,85.6560679 -0.293230911,82.5061023 1.18294823,79.918927 C4.06409569,74.8694019 7.08452677,69.9151668 10.2442415,65.0562218 C13.7166482,59.7164253 17.3572701,54.4917123 21.1661074,49.3820827 C22.3855127,47.7462265 24.0761327,46.5225175 26.0110609,45.8751942 C33.5582472,43.350315 41.221227,41.9760048 49.0000005,41.7522635 L49.0000005,41.7196318 C49.3789889,41.7196318 49.757704,41.7223471 50.1361458,41.7277779 C50.5145877,41.7223471 50.8933028,41.7196318 51.2722912,41.7196318 C51.2722912,41.7305006 51.2722912,41.7413779 51.2722912,41.7522635 C59.0510646,41.9760048 66.7140445,43.350315 74.2612307,45.8751942 C76.1961589,46.5225175 77.8867789,47.7462265 79.1061843,49.3820827 C82.9150215,54.4917123 86.5556435,59.7164253 90.0280502,65.0562218 C93.1877649,69.9151668 96.208196,74.8694019 99.0893434,79.918927 C100.565523,82.5061023 100.666014,85.6560679 99.3577378,88.3320713 L93.6533836,100 L81.1235909,100 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5373267,100 C73.5373267,87.2832429 64.1666072,80 50.1891028,80 C36.2115983,80 26.8009962,87.3867638 26.8009962,100 C40.0943409,100 45.4455447,100 73.5373267,100 Z",
    id: "Oval-Copy-7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 50.1891028,
    cy: 19.5,
    rx: 17.5,
    ry: 19.5
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverIcon);
export default __webpack_public_path__ + "static/media/driver_icon.150a6f7b4adc75f5efaeffa2d9af01ee.svg";
export { ForwardRef as ReactComponent };